import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import ReactSelectBaseField from "./ReactSelectBaseField";

const SelectField = ({ descriptor, formHandler }: FormFieldProps) => {
  // render
  return (
    <ReactSelectBaseField 
      descriptor={descriptor}
      formHandler={formHandler}
    />
  );
};

export default SelectField;
